import { VolumeBasedTariffService } from 'app/_services/volume-based-tariff.service';
import * as angular from 'angular';
import { Decimal } from 'decimal.js';

class TariffGroupsComponentCtrl implements ng.IController {
    minQuantity: QuantityDto;
    maxQuantity: QuantityDto;
    tariffGroups: TariffGroupDto[];
    algorithmType: 'SHORT_TERM' | 'LONG_TERM';
    fallbackTariff: QuantityDto;

    constructor(private volumeBasedTariffService: VolumeBasedTariffService) {}

    $onInit() {}

    calcTariff(
        price: PriceDto,
        alpha: { value: Decimal },
        duration: { value: Decimal },
        maxVolume: QuantityDto,
        minVolume: QuantityDto
    ): string | null {
        if (!this.maxQuantity || !this.maxQuantity.originalValue) return null;

        try {
            return this.volumeBasedTariffService
                .calculateVolumeBasedTariff(
                    price.value.value as Decimal,
                    alpha.value as Decimal,
                    duration.value as Decimal,
                    maxVolume.originalValue.value as Decimal,
                    minVolume.originalValue.value as Decimal,
                    new Decimal(this.maxQuantity.originalValue.value)
                )
                .toString();
        } catch (e) {
            return null;
        }
    }

    /**
     * The max quantity of the bid should be within the range of the tariff group to be displayed.
     * When none of the tariff groups are matched by the filter, the fallback tariff {@link app.pkpTariffGroups#fallbackTariff} will be displayed.
     */
    filterTariffGroups(): ng.IFilterFilterPredicateFunc<TariffGroupDto> {
        return (tariffGroup: TariffGroupDto) => {
            try {
                const minQuantity: Decimal = new Decimal(
                    this.minQuantity.originalValue.value
                );
                const maxQuantity: Decimal = new Decimal(
                    this.maxQuantity.originalValue.value
                );
                const tariffGroupMaxVolume: Decimal = new Decimal(
                    tariffGroup.maxVolume.originalValue.value
                );
                const tariffGroupMinVolume: Decimal = new Decimal(
                    tariffGroup.minVolume.originalValue.value
                );

                return this.volumeBasedTariffService.matchesTariffGroup(
                    maxQuantity,
                    tariffGroupMinVolume,
                    minQuantity,
                    tariffGroupMaxVolume
                );
            } catch (e) {
                return false; // Just show the tariff group when in doubt to let it to the user to decide.
            }
        };
    }
}

angular.module('app').component('pkpTariffGroups', {
    controller: TariffGroupsComponentCtrl,
    template: require('app/volume-based-tariff/tariff-groups.component.html'),
    bindings: {
        tariffGroups: '=',
        maxQuantity: '=',
        minQuantity: '=',
        algorithmType: '=',
        fallbackTariff: '=?'
    }
});
